import { WattiActionTypes } from "./constants";

export const wattiApiResponseSuccess = (actionType: string, data: any) => ({
  type: WattiActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const wattiApiResponseError = (actionType: string, error: string) => ({
  type: WattiActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getWattiTemplates = () => ({
  type: WattiActionTypes.GET_WATTI_TEMPLATES,
  payload: {},
});

export const sendWattiBroadcast = (
  template_name: string,
  recipients: string[]
) => ({
  type: WattiActionTypes.SEND_WATTI_BROADCAST,
  payload: { template_name, recipients },
});
